<template>

  <div class="main-wrapper">
    <layouts></layouts>
    <router-view v-slot='{ Component }'>
      <div class="breadcrumb-bar p-0">
        <div class="container p-3">
          <div class="breadcrumb-list">
            <nav aria-label="breadcrumb" class="page-breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item" v-for="(item, i) in route" :key="i">
                  <router-link :to="item.path" v-if="item.path">{{ item.name }}</router-link>
                  <router-link class="text-muted" to="" v-else>{{ item.name }}</router-link>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <nav class="navbar navbar-light alert-warning text-black" v-if="checkModoAluno()">
        <div class="container-fluid">
          <div class="container">
            Modo aluno visualizando como: <b class="text-black">{{ getNomeModoAluno() }}</b>
            <a class="link-danger pull-end text-danger" href="javascript:void(0)" @click="sairModoAluno">Sair do modo
              aluno</a>
          </div>
        </div>
      </nav>
      <div class="page-content">
        <div class="container">
          <div class="row" v-if="showSideBar">
            <div class="col-xl-3 col-lg-4 col-md-12 theiaStickySidebar">
              <sidebar></sidebar>
            </div>
            <div class="col-xl-9 col-lg-8 col-md-12">
              <component :is='Component'/>
            </div>
          </div>
          <component v-else :is='Component'/>
        </div>
      </div>
    </router-view>
    <layouts1></layouts1>
  </div>
</template>

<script>
import {useRoute} from "vue-router";
import ModoAluno from "../helpers/helper.modo.aluno"

export default {
  name: "DefaultLayout",
  mixins: [ModoAluno],
  data() {
    return {
      route: [],
      fullPath: '',
      menuList: [
        // '/academico',
        // '/administrativo'
      ]
    }
  },
  computed: {
    showSideBar() {
      if (this.$route.matched[0].path == '/pages')
        return this.menuList.includes(this.$route.matched[1].path)
      return false
    },
  },
  mounted() {
    const route = useRoute()
    this.breadcrumb(route)
  },
  methods: {
    breadcrumb(route) {
      // Rastreia o caminho completo para decidir o que exibir no breadcrumb raiz.
      this.fullPath = route.fullPath;
      let path = []
      route.matched.forEach(item => {

        // Evita duplicar nomes e ignora itens sem nome.
        if (item.name != '' && !path.map(i => i.name).includes(item.name)){


          // Não cria link para entradas raiz; exibe como texto simples.
          if (['/inicio', '/aluno/sala-de-aula', '/aluno/documentos/:tipo?'].includes(item.path.toLowerCase()) ||
            item.path == `/${this.fullPath.split('/')[1]}`) {
            path.push({
              path: null,
              name: item.name
            });

          }else{
            // Demais entradas apontam para o caminho da rota.
            path.push({
              path: item.path,
              name: item.name
            });
          }
        }
      })

      // Inclui o parametro "tipo" no breadcrumb somente para /aluno/documentos.
      if (route.path.toLowerCase().startsWith('/aluno/documentos/') && route.params?.tipo) {
        const tipoRaw = String(route.params.tipo)
        const tipoLabelMap = {
          'meus-documentos': this.$t('documents.myDocumentsTitle'),
          'requisicoes': this.$t('documents.requisitionsTitle'),
          'requisicoes-carteirinha-digital': this.$t('documents.digitalStudentIdTitle'),
          'requisicoes-atestado-matricula': this.$t('documents.enrollmentCertificateTitle'),
          'requisicoes-contrato': this.$t('documents.contractTitle'),
          'requisicoes-demonstrativo-financeiro': this.$t('documents.financialStatementTitle'),
          'requisicoes-historico-escolar': this.$t('documents.academicTranscriptTitle'),
        }
        const tipoLabel = tipoLabelMap[tipoRaw] ?? ''
        path.push({
          path: null,
          name: tipoLabel
        });
      }
      // Pers
      // iste a lista de breadcrumb calculada para renderização.
      this.route = path;
    },
  },
  watch: {
    $route(to, from) {
      this.breadcrumb(to);
    }
  }
}
</script>

<style scoped>

</style>
